export default "<div data-ng-bind-html=\"options.templateOptions.label | nl2br | a2nt | videoUrlToIframe\" class=\"readonly\"></div>";